import createCache from '@emotion/cache';
import type { StylisPlugin } from '@emotion/cache';
import { prefixer } from 'stylis';
import { darkenCssValue, roleForProperty } from './darkColors';

// Rewrites the colors of every declaration Emotion generates (MUI's own styles,
// sx, styled(), GlobalStyles) as it is inserted. Runs before `prefixer` so the
// vendor-prefixed copies are built from the converted value.
export const darkModeStylisPlugin: StylisPlugin = (element) => {
  if (element.type !== 'decl') return;
  const prop = String(element.props);
  const role = roleForProperty(prop);
  if (!role) return;
  const value = String(element.children);
  const next = darkenCssValue(value, role);
  if (next === value) return;
  element.value = `${prop}:${next};`;
  element.children = next;
};

// Light keeps Emotion's default key, so class names are exactly what they were
// before dark mode existed. Dark gets its own key: switching the provider's
// cache re-renders every styled component into fresh `dk-*` classes, which is
// how MUI's documented RTL switch works too. Custom plugins replace Emotion's
// default [prefixer], so it is added back explicitly.
export const lightEmotionCache = createCache({ key: 'css' });
export const darkEmotionCache = createCache({
  key: 'dk',
  stylisPlugins: [darkModeStylisPlugin, prefixer],
});
